/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiPriorityClassPoolResourceLimits
 */
export interface ApiPriorityClassPoolResourceLimits {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ApiPriorityClassPoolResourceLimits
     */
    maximumResourceFraction?: { [key: string]: number; };
}

export function ApiPriorityClassPoolResourceLimitsFromJSON(json: any): ApiPriorityClassPoolResourceLimits {
    return ApiPriorityClassPoolResourceLimitsFromJSONTyped(json, false);
}

export function ApiPriorityClassPoolResourceLimitsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPriorityClassPoolResourceLimits {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'maximumResourceFraction': !exists(json, 'maximumResourceFraction') ? undefined : json['maximumResourceFraction'],
    };
}

export function ApiPriorityClassPoolResourceLimitsToJSON(value?: ApiPriorityClassPoolResourceLimits | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'maximumResourceFraction': value.maximumResourceFraction,
    };
}

